var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_12040)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 3.41699C5.41904 3.41699 5.08325 3.75278 5.08325 4.16699V10.0003C5.08325 10.0003 5.08325 10.0004 5.08325 10.0004V15.8337C5.08325 16.2479 5.41904 16.5837 5.83325 16.5837H11.6666C12.639 16.5837 13.5717 16.1974 14.2593 15.5098C14.9469 14.8221 15.3333 13.8895 15.3333 12.917C15.3333 11.9446 14.9469 11.0119 14.2593 10.3243C14.0062 10.0712 13.7199 9.8589 13.4106 9.69168C13.4157 9.6866 13.4209 9.6815 13.426 9.67638C14.1136 8.98875 14.4999 8.05612 14.4999 7.08366C14.4999 6.1112 14.1136 5.17857 13.426 4.49093C12.7383 3.8033 11.8057 3.41699 10.8333 3.41699H5.83325ZM10.8254 10.7503H6.58325V15.0837H11.6666C12.2412 15.0837 12.7923 14.8554 13.1987 14.4491C13.605 14.0428 13.8333 13.4917 13.8333 12.917C13.8333 12.3424 13.605 11.7913 13.1987 11.385C12.7923 10.9786 12.2412 10.7504 11.6666 10.7504H10.8333C10.8306 10.7504 10.828 10.7504 10.8254 10.7503ZM6.58325 9.25033V4.91699H10.8333C11.4079 4.91699 11.959 5.14527 12.3653 5.55159C12.7716 5.95792 12.9999 6.50902 12.9999 7.08366C12.9999 7.65829 12.7716 8.20939 12.3653 8.61572C11.959 9.02205 11.4079 9.25033 10.8333 9.25033H6.58325Z",
    fill: "#2B2B35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_12040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.49de680ac65c1789b0ff117cd80dc6e4.svg";
export { ForwardRef as ReactComponent };